import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { header, innerHeader, logo } from "./header.module.scss"
import Logo from "../../images/logo.svg"

const Header = () => (
  <header className={header}>
    <div className={innerHeader}>
      <Link to="/">
        <Logo className={logo} />
      </Link>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
